//Импортировать formatNumber только из @shared/lib
import { formatNumber } from '@shared/lib';

export default formatNumber;
